function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4625_5975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
  stroke: "white",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 9.036V6H14.082V18.0615H10.6995V9.036H9Z",
  fill: "#FFFDF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.99995 10.5L6.33672 11.5365H7.42654L6.54486 12.177L6.88164 13.2135L5.99995 12.573L5.11827 13.2135L5.45505 12.177L4.57336 11.5365H5.66319L5.99995 10.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 10.5L18.3368 11.5365H19.4267L18.545 12.177L18.8817 13.2135L18 12.573L17.1183 13.2135L17.4551 12.177L16.5734 11.5365H17.6633L18 10.5Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4625_5975"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
var SvgTooMechanicalWarranty = function SvgTooMechanicalWarranty(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTooMechanicalWarranty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/too_mechanical_warranty.85c0183d.svg";
export { ForwardRef as ReactComponent };